export default "__VITE_ASSET__p561Xdyo__"